import { useState, useRef, useEffect } from "react";
import { aiChatBotMauiLaptop } from "../services/apiService";
import { v4 as uuidv4 } from 'uuid';
import VoiceRecorder, { VoiceRecorderHandle } from "../components/VoiceRecorder";
import send from "../assects/img/Send.png" 
import gray_send from "../assects/img/Gray_Send.png" 

interface Message {
  sender: "user" | "bot" | "loading";
  text: string;
}

function MauiLaptopV1() {
  const [messages, setMessages] = useState<Message[]>([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [wholeLoading, setWholeLoading] = useState(false);
  const chatEndRef = useRef<HTMLDivElement>(null);
  const [current_user_chat_code, setCurrent_user_chat_code] = useState("");

  const voiceRecorderRef = useRef<VoiceRecorderHandle>(null);

  const scrollToBottom = () => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const CC = uuidv4() 
    setCurrent_user_chat_code(CC);
    const init = async () => {
        setWholeLoading(true);
        await handleBotReply("SUBS123",CC);
        setWholeLoading(false);
    };

    init();
  }, []);

  const handleBotReply = async (userInput: string, cc?: any, audioBlob?: Blob) => {
    try {
      setLoading(true);

      const formData = new FormData();
      let audio = false;

      voiceRecorderRef.current?.stopRecording();

      if (audioBlob) {
        formData.append('audio', audioBlob, 'voice.webm');
        formData.append('userQuery', "");
        setMessages(prev => [...prev, { sender: "user", text: "🎤 (voice message sent)" }]);
        setMessages(prev => [...prev, { sender: "loading", text: "🤖 Getting response..." }]);
        audio = true;
      } else {
        formData.append('userQuery', userInput);
        if(userInput !== "SUBS123"){
            const userMessage: Message = { sender: "user", text: input };
            setMessages((prev) => [...prev, userMessage]);
        }
        
        setMessages((prev) => [...prev, { sender: "loading", text: "🤖 Getting response..." }]);
      }

      formData.append('current_user_chat_code', current_user_chat_code || cc);

      const response = await aiChatBotMauiLaptop(formData);
      const userAudioText = response.transcribed_text;
      const botReply = response.reply || "No response";

      if (audio) {
        setMessages((prev: any) => {
          const updated = prev.map((msg: any, index: number) => {
            if (index === prev.length - 2) {
              return { ...msg, text: `🎤 (voice message sent) - ${userAudioText}` };
            } else {
              return msg;
            }
          });
          return [...updated];
        });
      }

      setMessages((prev) => {
        const filtered = prev.filter(msg => msg.text !== "🤖 Getting response...");
        return [...filtered, { sender: "bot", text: botReply }];
      });

      if (response.role !== "") {
        localStorage.setItem('userBotRole', response.role);
      }
    } catch (error) {
      setMessages((prev) => [
        ...prev,
        { sender: "bot", text: "Sorry, something went wrong." },
      ]);
      setMessages((prev) => {
        const filtered = prev.filter(msg => msg.text !== "🤖 Getting response...");
        return [...filtered];
      });
    } finally {
      setLoading(false);
    }
  };

  const sendMessage = async (audioBlob?: Blob) => {
    const currentInput = input;
    setInput("");
    await handleBotReply(currentInput, "" , audioBlob);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") sendMessage();
  };


  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  return (
    <div className="w-full h-screen flex flex-col items-center justify-between bg-gray-100 font-sans">
    <div className="w-full text-left px-6 pt-6 text-lg font-semibold">
      <span className="text-gray-800">XORO Story's  </span>
      <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#f06292] to-[#ba68c8] font-bold">Maui</span>
    </div>

    <div className="flex-1 w-full px-20 py-4 overflow-y-auto space-y-4">
      {messages.map((msg, index) => (
        <div
          key={index}
          className={`px-5 py-4 rounded-xl text-sm leading-relaxed aaa ${
            msg.sender === "user"
              ? "bg-[#5D67F2] text-white w-fit max-w-[50%] self-end ml-auto"
              : msg.sender === "loading"
              ? "bg-white text-gray-600 w-fit max-w-[80%] self-start mr-auto"
              : "bg-white text-gray-800 w-fit max-w-[80%] self-start mr-auto"
          }`}
          dangerouslySetInnerHTML={{
            __html:
              msg.text === "🤖 Getting response..."
                ? `<div class="flex items-center space-x-2">
                    <span class="text-sm">Getting Response</span>
                    <div class="flex space-x-1">
                      <div class="h-2 w-2 bg-gray-600 rounded-full animate-bounce" style="animation-delay: 0s;"></div>
                      <div class="h-2 w-2 bg-gray-600 rounded-full animate-bounce" style="animation-delay: 0.1s;"></div>
                      <div class="h-2 w-2 bg-gray-600 rounded-full animate-bounce" style="animation-delay: 0.2s;"></div>
                    </div>
                  </div>`
                : msg.text,
          }}
        />
      ))}
      <div ref={chatEndRef} />
    </div>

    <div className="w-[50%] px-6 pb-20 flex items-center h-[60px]">
      <div className="flex items-center justify-between bg-white rounded-full shadow-md px-4 pe-0 py-2 w-[90%] h-[60px]">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="What’s in your mind?…"
          className="flex-1 px-2 py-1 text-sm bg-transparent focus:outline-none w-[90%]"
        />
        <button onClick={() => sendMessage()} disabled={loading} className="h-[60px] py-1 w-[10%]">
          {loading ? <img src={gray_send} alt="send" className=" h-full"/> : <img src={send} alt="send" className=" h-full"/>}
        </button>
      </div>
      <div className="">
        <VoiceRecorder
          ref={voiceRecorderRef}
          onAudioRecorded={(audioBlob: Blob) => sendMessage(audioBlob)}
          disabled={loading}
        />
      </div>
    </div>
      {
        wholeLoading && <div style={{position:'fixed',top:'0',bottom:'0',width:'100%',display:'flex',alignItems:'center',justifyContent:'center',backgroundColor: 'rgba(0, 0, 0, 0.5)'}}>
                            <div style={{background:'white',border:' 2px solid #0050C8'}} className="flex items-center rounded px-7 py-3">
                                <div className="spinner me-2"></div>
                                <p className="text-blue-700">Preparing your chat please wait...</p> 
                            </div>
                        </div>
      }
    </div>
  );

}

export default MauiLaptopV1;
